// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { LoginComponent } from "@lg/ng-shared";

interface Properties {
    redirect: string;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-Login',
    templateUrl: './Login.html',
    styleUrls: ['./Login.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        LoginComponent
    ],
})
export class Login extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.Login';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    input_redirect = input(undefined, { alias: 'redirect' });
    var_redirect = proxySignal<string>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get redirect() { return component.var_redirect() },
                set redirect(value: string) { component.var_redirect.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            redirect: this.screen.redirect
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_redirect = this.dialogData?.data?.redirect ?? this.input_redirect() ?? (undefined)
            if (new_redirect !== undefined) this.screen.redirect = new_redirect

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
